export default async function requestRequisicaoSegura(dataEncriptada: string) {
  const url = window?.location?.origin ?? process.env.NEXT_PUBLIC_API_URL!;
  return await fetch(`${url}/api/requisicao-segura`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      dataEncriptada,
    }),
  });
}
